import React from 'react';
import { HiOutlineInbox, HiOutlineCalendar, HiOutlineTicket } from 'react-icons/hi';
import './emptyState.css';

type EmptyStateIcon = 'inbox' | 'calendar' | 'ticket';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  compact?: boolean;
  inline?: boolean;
  icon?: EmptyStateIcon;
}

const icons: Record<EmptyStateIcon, React.ElementType> = {
  inbox: HiOutlineInbox,
  calendar: HiOutlineCalendar,
  ticket: HiOutlineTicket,
};

function EmptyState({
  title,
  subtitle,
  compact = false,
  inline = false,
  icon = 'inbox',
}: EmptyStateProps) {
  const Icon = icons[icon];
  const classNames = [
    'empty-state',
    compact ? 'empty-state--compact' : '',
    inline ? 'empty-state--inline' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames}>
      <Icon className="empty-state__icon" aria-hidden="true" />
      <p className="empty-state__title">{title}</p>
      {subtitle && <p className="empty-state__subtitle">{subtitle}</p>}
    </div>
  );
}

export default EmptyState;
